"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var ETypes = (0, _keyMirror.default)({
  dealCreated: null,
  dealstageChange: null,
  eventAnalytics: null,
  eventAutomation: null,
  eventAutomationPlatform: null,
  eventAdInteraction: null,
  eventBiden: null,
  eventEmailUnbounce: null,
  eventCtaClick: null,
  eventEmailOptOut: null,
  eventEmailSend: null,
  eventEngagement: null,
  eventFeedbackSubmission: null,
  eventFormSubmission: null,
  eventIntegrations: null,
  eventLifecycleStage: null,
  eventListMembership: null,
  eventMerge: null,
  eventMessages: null,
  eventMonth: null,
  eventPageView: null,
  eventPresentation: null,
  eventPrivacyConsent: null,
  eventSalesforceSync: null,
  eventSequence: null,
  eventSidekick: null,
  eventSurveyMonkeySurvey: null,
  eventTicket: null,
  eventTwitterMatch: null,
  eventWebinarAttendance: null,
  eventWebinarRegistration: null,
  eventWistia: null,
  eventCreateSource: null,
  eventTicketStageChange: null,
  eventTicketCreated: null,
  eventProductQuote: null
});
var _default = ETypes;
exports.default = _default;
module.exports = exports.default;